<template>
	<div v-if="hasNonCommentContent" v-html="marketingHtml" :class="['espot-container', espotClass]"></div>
</template>

<script>
import EspotContainer from "./EspotContainer.ts";
export default {
	...EspotContainer,
};
</script>
<style lang="scss">
@import "./EspotContainer.scss";
</style>
